module.exports = __webpack_public_path__ + "img/loading.1f40b2c6.gif";